type Props = {
  completed: number
  total: number
}

export const StagesProgress = ({ completed, total }: Props) => {
  if (total === 0) return <span className="text-app-muted">—</span>
  const pct = Math.round((completed / total) * 100)
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 h-1.5 bg-app-subtle rounded-full overflow-hidden min-w-[60px] max-w-[80px]">
        <div
          className={`h-full rounded-full transition-all ${
            pct === 100 ? 'bg-emerald-500' : pct > 50 ? 'bg-sky-500' : 'bg-app-muted'
          }`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs text-app-muted tabular-nums">{completed}/{total}</span>
    </div>
  )
}
